module.exports = __webpack_public_path__ + "img/doc_view_tile2.f2e494a2.png";